import { FC, useEffect } from 'react';
import { Form, FormInstance, FormItemProps } from 'antd';
import { NamePath } from 'antd/lib/form/interface';

export interface IFormItemControlProps extends Omit<FormItemProps, 'validateTrigger'> {
  name?: NamePath;
  form?: FormInstance<any>;
  formListName?: string;
  visible?: (formInstance: FormInstance) => boolean; // to trigger this feature, have to pass `shouldUpdate` OR `dependencies` prop as well
  disableError?: boolean;
}

export const FormItemControl: FC<IFormItemControlProps> = ({
  name,
  isListField,
  children,
  formListName,
  visible,
  disableError,
  ...propsRest
}) => {
  const combinedName = formListName ? [formListName, ...((name as Array<any>) || [])] : name ?? '';
  const form = Form.useFormInstance();
  const watchValue = Form.useWatch(combinedName, form);

  useEffect(() => {
    if (isListField && !formListName) {
      console.error('Warning: Need to provide [formListName] property for FormItemControl component!!');
    }
  }, []);

  useEffect(() => {
    if (form.getFieldError(combinedName).length > 0) {
      form.validateFields([combinedName]);
    }
  }, [watchValue]);

  if (visible)
    return (
      <Form.Item noStyle shouldUpdate={propsRest.shouldUpdate} dependencies={propsRest.dependencies}>
        {(formInstance: FormInstance) => (visible(formInstance) ? children : null)}
      </Form.Item>
    );

  return (
    <Form.Item
      name={name}
      isListField={isListField}
      {...propsRest}
      validateTrigger={['onSubmit', 'onBlur']}
      validateStatus={disableError ? 'success' : undefined}
      help={disableError ? '' : undefined}
    >
      {children}
    </Form.Item>
  );
};
